export default "__VITE_ASSET__82139e58__"